import { render, staticRenderFns } from "./Rushes.vue?vue&type=template&id=2549c65a&scoped=true&"
import script from "./Rushes.vue?vue&type=script&lang=js&"
export * from "./Rushes.vue?vue&type=script&lang=js&"
import style0 from "./Rushes.vue?vue&type=style&index=0&id=2549c65a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2549c65a",
  null
  
)

export default component.exports